import { generateApiPath } from '@scouts/helpers'

import { SubscriptionTaxRegime } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'

export interface UpdateSubscriptionTaxRegimeDTO {
    taxRegime: SubscriptionTaxRegime
}

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateSubscriptionTaxRegime: builder.mutation<void, UpdateSubscriptionTaxRegimeDTO>({
            query: (data) => ({
                method: 'PUT',
                url: generateApiPath(ENDPOINTS.SUBSCRIPTION.PUT.TAX_REGIME),
                data,
            }),
        }),
    }),
})

export const { useUpdateSubscriptionTaxRegimeMutation } = extendedApi
